<div class="modal-wrapper" [class.active]="isActive">
	<div class="modal" [class.active]="isActive" [class.wide]="isWide">
		<div class="modal-content" [ngClass]="type">
			<div class="modal-header">
				<span class="close" (click)="onReject()">×</span>
				<h2><ng-content *ngIf="!disableHeader" select="div[role=header]"></ng-content></h2>
			</div>
			<div class="modal-body nav">
				<ng-content select="div[role=body]"></ng-content>
			</div>
			<div class="modal-footer" *ngIf="!disableFooter">
				<ng-content select="div[role=footer]"></ng-content>
				<div class="button-group">
					<dx-button stylingMode="contained" type="default" class="action-button" name="accept" (click)="onAccept()"
						*ngIf="isActive && acceptText?.length > 0">{{ acceptText }}</dx-button>
					<dx-button stylingMode="outlined" type="default" class="action-button" name="reject" (click)="onReject()"
						*ngIf="isActive && rejectText?.length > 0">{{ rejectText }}</dx-button>
				</div>
			</div>
		</div>
	</div> 
</div>
